@if (!project) {
<div class="spinner-wrapper">
  <mat-spinner></mat-spinner>
</div>
}

<div class="content">
  <div class="page-content">
    @if (!!project) {
    <app-info-card
      [title]="project.name"
      description="{{ project.description }}"
      [infoMap]="infoMap"
      [columns]="this.solution === 'humidity' ? 2 : 4"
      [solution]="this.solution"
    ></app-info-card>
    }
  </div>
  <div class="project-card info-card">
    <mat-sidenav-container class="full-height br-8 sidenav-container" autosize>
      <mat-sidenav
        class="sidenav-drawer"
        [opened]="isDrawerOpen"
        [mode]="bp.isCompact() ? 'over' : 'side'"
        [disableClose]="!bp.isCompact()"
        (closedStart)="isDrawerOpen = false"
      >
        @if (bp.isCompact()) {
        <!-- the drawer covers the map (and its toggle) below 1024px, so the handle sits on the drawer's right edge -->
        <button
          type="button"
          class="btn-toggle btn-toggle-drawer"
          aria-expanded="true"
          [attr.aria-label]="'SHARED.TOGGLE_LIST' | translate"
          (click)="toggle()"
        >
          <svg-icon src="/assets/icons/icon-40-collapse.svg" [class]="'icon-mobile'"></svg-icon>
        </button>
        }
        <div class="flex-col drawer-body">
          <div class="drawer-head">
            <span class="auto-margin-top-bottom title">Components</span>
            @if (solution === 'utilization') {
            <div>
              <button mat-button [matMenuTriggerFor]="menu">
                <div>
                  <svg-icon class="pr-xm" [src]="displayedCompFilters.icon"></svg-icon>
                  {{ displayedCompFilters.text }}
                  <mat-icon style="padding-left: 12px">keyboard_arrow_down</mat-icon>
                </div>
              </button>
              <mat-menu #menu="matMenu">
                @for (measurement of measurements; track measurement) {
                <button
                  class="filter-submenu"
                  mat-menu-item
                  [value]="measurement.key"
                  (click)="filterByUsage(measurement)"
                >
                  <div>
                    <svg-icon class="pr-xm" [src]="measurement.icon"></svg-icon>
                    {{ measurement.value }}
                  </div>
                </button>
                }
              </mat-menu>
            </div>
            }
          </div>
          @if (isComponentLoaded) {
          <app-table
            [tableCols]="displayedColumns"
            (rowClicked)="onRowClicked($event)"
            [dataSource]="dataSource"
          ></app-table>
          @if (dataSource.length === 0) {
          <div style="text-align: center; padding-top: 64px">
            <h2>No data available</h2>
            <!--TODO fix this section after more inputs-->
            @if (false) {
            <h4 class="text-empty-label mb-m">Why not check data collected in ...</h4>
            <button mat-flat-button style="background-color: #4682b4; color: white">Last 3 Months</button>
            }
          </div>
          } } @if (!isComponentLoaded) {
          <h2 class="text-empty-label mt-l">Loading components ...</h2>
          }
        </div>
      </mat-sidenav>
      <mat-sidenav-content style="position: relative">
        @if (markerData) {
        <app-map-view
          mapId="project-detail"
          [markerData]="markerData"
          [hasRouting]="false"
          [clusterPoints]="clusterPoints"
          [solution]="solution"
        ></app-map-view>
        }
        <button
          type="button"
          class="btn-toggle"
          [attr.aria-expanded]="isDrawerOpen"
          [attr.aria-label]="'SHARED.TOGGLE_LIST' | translate"
          (click)="toggle()"
        >
          @if (isDrawerOpen) {
          <svg-icon src="/assets/icons/icon-40-collapse.svg" [class]="'icon-mobile'"></svg-icon>
          } @if (!isDrawerOpen) {
          <svg-icon src="/assets/icons/icon-40-expand.svg" [class]="'icon-mobile'"></svg-icon>
          }
        </button>
      </mat-sidenav-content>
    </mat-sidenav-container>
  </div>
</div>
